import api from 'api/axiosInstance';
import type { SubscriptionCounterKeysEnum } from 'types/subscriptions.types';

type FeatureCountsResponse = {
  [key in SubscriptionCounterKeysEnum]: number;
};

const getFeatureCounts = async (): Promise<FeatureCountsResponse> =>
  api.get('/v2/users/feature-counters');

export default getFeatureCounts;
